export enum SubscriptionItemNames {
  LimbiksProNewSubscription = 'Limbiks Pro - New Subscription',
  LimbiksProRenewal = 'Limbiks Pro - Renewal',
  LimbiksProUpdate = 'Limbiks Pro - Update'
}
